import { parseWritingGuideRenderHostContract } from '@crabs-ai/alphabet-writing-runtime/contracts';

import renderHostContract from '../../../../../../public/agent-workflow/alphabet-authoring/runtime/remotion-render-host-contract.v2.json';

export const WRITING_GUIDE_RENDER_HOST_CONTRACT =
  parseWritingGuideRenderHostContract(renderHostContract);
